"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VideoPlayOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,4H27V6h1ZM4,22V10H28V22ZM7,6H9V8H7ZM23,6h2V8H23ZM21,8H19V6h2ZM17,8H15V6h2ZM13,8H11V6h2ZM5,6V8H4V6ZM4,26V24H5v2Zm3,0V24H9v2Zm4,0V24h2v2Zm4,0V24h2v2Zm4,0V24h2v2Zm4,0V24h2v2Zm4,0V24h1v2Z"/><path d="M19.51,15.05l-6.06-3.91A.9.9,0,0,0,13,11a.88.88,0,0,0-.49.15,1.12,1.12,0,0,0-.48.95v7.8a1.12,1.12,0,0,0,.48,1A.91.91,0,0,0,13,21a.9.9,0,0,0,.48-.14L19.51,17a1.17,1.17,0,0,0,0-1.9ZM14,18.12V13.88L17.3,16Z"/>';
var VideoPlayOutlineSVG = function VideoPlayOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.VideoPlayOutlineSVG = VideoPlayOutlineSVG;
VideoPlayOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(VideoPlayOutlineSVG);
exports.default = _default;